import { render } from "./Researchers.vue?vue&type=template&id=a7c1a38a"
import script from "./Researchers.vue?vue&type=script&lang=js"
export * from "./Researchers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__